import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueSweetalert2 from 'vue-sweetalert2'
import cookies from 'vue-cookies'
import 'sweetalert2/dist/sweetalert2.min.css'
import 'moment/locale/es'
import './assets/scss/estilos.scss'
import VueMoment from 'vue-moment'
import VueSocketIO from 'vue-socket.io'
import VueMask from 'v-mask'
import VueApexCharts from 'vue-apexcharts'
import * as VueGoogleMaps from 'vue2-google-maps'

const moment = require('moment')
Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)
Vue.use(VueMask)
moment.locale('es')
Vue.use(VueMoment, {
  moment
})
Vue.config.productionTip = false
Vue.use(VueAxios, axios)
Vue.use(VueSweetalert2)
Vue.use(cookies)

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyCeheP7N3nMtkIeE2P56lW1umQM1fyHCwE',
    libraries: 'places,directions' // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    /// / If you want to set the version, you can do so:
    // v: '3.26',
  }
})

Vue.use(new VueSocketIO({
  debug: false,
  // connection: 'http://localhost:9004'
  connection: 'http://api.administrativo.dvrve.net'
}))

// Filters
Vue.filter('read', function (val) {
  return Number.parseFloat(val).toFixed(2)
})

Vue.filter('write', function (val, oldVal) {
  let number = +val.replace(/[^\d.]/g, '')
  return isNaN(number) ? 0 : parseFloat(number.toFixed(2))
})

Vue.directive('uppercase', {
  /* bind (el, _, vnode) {
    el.addEventListener('input', (e) => {
      e.target.value = e.target.value.toUpperCase()
      vnode.componentInstance.$emit('input', e.target.value.toUpperCase())
    })
  } */
})

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
